import React, { useState, useContext } from 'react';
import { CircularProgress } from '@material-ui/core';

export const LoadingContext = React.createContext();

export function LoadingProvider({ children }) {
  const [isLoading, setLoading] = useState(false);
  const [size, setSize] = useState({
    height: '100%',
    width: '100%',
  });

  function updateState(value) {
    if (value) {
      const el = document.getElementById('principal-container').lastChild;
      setSize({
        width: el.offsetWidth,
        height: el.offsetHeight,
      });
    }
    setLoading(value);
  }

  return (
    <LoadingContext.Provider value={{ updateState, isLoading }}>
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute"
          style={{
            zIndex: 2000,
            minWidth: size.width,
            minHeight: size.height,
            background: 'white',
            opacity: 0.9,
          }}
        >
          <CircularProgress color="secondary"></CircularProgress>
        </div>
      )}
      {children}
    </LoadingContext.Provider>
  );
}

export const useLoading = () => useContext(LoadingContext);
